import React from 'react';
import { Toast } from 'react-bootstrap';
// Toast component for incident notification

import Image from "../components/image";
import { RefreshCcw,Cog,CircleCheck, CircleDashed, CircleX, FileCog, FileSearchCorner, LoaderCircle, TriangleAlert, Wrench } from "lucide-react";
// import { CircleCheck} from "lucide-react";

export function IncidentToast({ show, onClose, title, description, children }) {
    return (
        <div className="position-fixed p-3" style={{ top: '100px', right: '0', zIndex: '5'}}>
            <Toast
                className='toast-dark p-0 m-0'
                show={show}
                onClose={onClose}
                delay={300000}
                autohide
            >
                <Toast.Body>
                <div className="toast-action mr-2">
                    <button type="button" className="close" onClick={onClose}></button>
                </div>
                    <div className="d-flex align-items-center p-2">
                        <div className="toast-icon-wrap">
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.15571 26.3795C4.94135 26.3795 4.74649 26.3259 4.57111 26.2188C4.39573 26.1116 4.25932 25.9703 4.16189 25.7949C4.06446 25.6195 4.01087 25.4295 4.00112 25.2249C3.99138 25.0203 4.04497 24.8206 4.16189 24.6257L14.977 5.91858C15.0939 5.72372 15.2449 5.57757 15.43 5.48013C15.6151 5.3827 15.8051 5.33398 16 5.33398C16.1949 5.33398 16.3849 5.3827 16.57 5.48013C16.7551 5.57757 16.9061 5.72372 17.023 5.91858L27.8381 24.6257C27.955 24.8206 28.0086 25.0203 27.9989 25.2249C27.9891 25.4295 27.9355 25.6195 27.8381 25.7949C27.7407 25.9703 27.6043 26.1116 27.4289 26.2188C27.2535 26.3259 27.0586 26.3795 26.8443 26.3795H5.15571ZM16 22.8719C16.3313 22.8719 16.609 22.7599 16.8331 22.5358C17.0571 22.3117 17.1692 22.034 17.1692 21.7027C17.1692 21.3715 17.0571 21.0938 16.8331 20.8697C16.609 20.6456 16.3313 20.5335 16 20.5335C15.6687 20.5335 15.391 20.6456 15.1669 20.8697C14.9429 21.0938 14.8308 21.3715 14.8308 21.7027C14.8308 22.034 14.9429 22.3117 15.1669 22.5358C15.391 22.7599 15.6687 22.8719 16 22.8719ZM16 19.3643C16.3313 19.3643 16.609 19.2523 16.8331 19.0282C17.0571 18.8041 17.1692 18.5264 17.1692 18.1951V14.6876C17.1692 14.3563 17.0571 14.0786 16.8331 13.8545C16.609 13.6304 16.3313 13.5184 16 13.5184C15.6687 13.5184 15.391 13.6304 15.1669 13.8545C14.9429 14.0786 14.8308 14.3563 14.8308 14.6876V18.1951C14.8308 18.5264 14.9429 18.8041 15.1669 19.0282C15.391 19.2523 15.6687 19.3643 16 19.3643Z" fill="#FFD500" />
                            </svg>
                        </div>
                        {/* <div className="toast-content px-3">
                            {children ? children : <>
                                <h6 className='text-white'>{title}</h6>
                            <p
                            className="text-white"
                            style={{ overflowWrap: "anywhere", wordBreak: "break-word" }}
                            dangerouslySetInnerHTML={{ __html: description }}
                            >
                            {description}
                            </p>
                            </>}
                        </div> */}

                        <div className="toast-content px-3" style={{ minWidth: 0 }}>
  <h6 className="text-white">{title}</h6>
  <p
    className="text-white"
    style={{ overflowWrap: "anywhere", wordBreak: "break-word" }}
    dangerouslySetInnerHTML={{ __html: description }}
  />
</div>
                    </div>
                </Toast.Body>
            </Toast>
        </div>
    );
}

// Example handler for toggling the toast (to be used in a React component, not here)
// const [showIncidentToast, setShowIncidentToast] = useState(false);
// const handleCloseIncidentToast = () => setShowIncidentToast(!showIncidentToast);

export function getDatasourceIcon(pmType) {
    if (!pmType) {
        return null; // or a default icon if you prefer
    }
    let formattedType = pmType.toLowerCase().replace(/[\s-]/g, "_");
    
    const exactIconMap = {
        'snowflake': 'icon_snow_flake',
        's3': 'icon_aws_s3',
        'aws_s3': 'icon_aws_s3',
        'redshift': 'icon_aws_redshift',
        'aws_redshift': 'icon_aws_redshift',
        'athena': 'icon_aws_athena',
        'aws_athena': 'icon_aws_athena',
        'azure_blob': 'icon_azure_blob',
        'azure_databricks': 'icon_azure_databricks',
        'azure_databricks_table': 'icon_azure_databricks',
        'azure_datalake': 'icon_azure_datalake',
        'azure_synapse': 'icon_azure_synapse',
        'azure_synapse_ds': 'icon_azure_synapse',
        'gcp_sql': 'icon_gcp_sql_server',
        'gcp_sql_server': 'icon_gcp_sql_server',
        'big_query': 'icon_google_bigquery',
        'google_bigquery': 'icon_google_bigquery',
        'mysql': 'icon_mysql',
        'airflow': 'connector_icon_airflow',
        'glue': 'connector_icon_glue',
        'amazon_glue': 'connector_icon_glue',
        'dbt': 'connector_icon_dbt',
        'amazon_mwaa': 'connector_icon_amazon_mwaa',
        'mwaa': 'connector_icon_amazon_mwaa',
        'google_cloud_composer': 'connector_icon_composer',
        'composer': 'connector_icon_composer',
        'azure_data_factory': 'connector_icon_data_factory',
        'adf': 'connector_icon_data_factory',
        'powerbi': 'icon_powerbi_dark',
        'azure': 'connector_icon_azure',
        'postgresql': 'icon_postgresql', // Assuming this might exist or fallback
    };

    const src = exactIconMap[formattedType] || `icon_${formattedType}`;
    return (<Image src={src}  alt=""/>)
}

export function getConfigurationTypeBadge(pmType) {
    if (!pmType) {
        return null; // or a default icon if you prefer
    } // autoConfig
    return (pmType==="autoConfig"?<div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-bg-[#FAFAFA] dark:tw-bg-[#161622]">
   <Cog color="#717680" size={14} />
   <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#414651] dark:tw-text-[#B2B5BE]">Auto Config</span>
</div>
:
<div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-bg-[#FAFAFA] dark:tw-bg-[#161622]">
   <RefreshCcw color="#717680" size={14} />
   <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#414651] dark:tw-text-[#B2B5BE]">Manual Config</span>
</div>)
}

export function getDatasourceStatus(type) {
    console.log("beforetype:", type);
    type = type?.toLowerCase()?.replace(/ /g, "_"); 
    // console.log("aftertype:", type);
    switch (type) {
        case "in_progress":
            return (
                <div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#B2DDFF] tw-bg-[#EFF8FF]">
                    <LoaderCircle color="#2E90FA" size={14} />
                    <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#175CD3]">In Progress</span>
                </div>
            );
        case "failed":
            return (
                <div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#FECDCA] tw-bg-[#FEF3F2]">
                    <CircleX color="#F04438" size={14} />
                    <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#B42318]">Failed</span>
                </div>
            );
        // case "Initialized":
        //     return (
        //         <div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#D9D6FE] tw-bg-[#F4F3FF]">
        //             <CirclePlay color="#7A5AF8" size={14} />
        //             <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#5925DC]">Initialize</span>
        //         </div>
        //     );
        case "not_started":
            return (
                <div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-bg-[#FAFAFA] dark:tw-bg-[#161622]">
                    <CircleDashed color="#717680" size={14} />
                    <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#414651] dark:tw-text-[#B2B5BE]">Not Yet Started</span>
                </div>
            );
        case "incomplete":
            return (
                <div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#FEDF89] tw-bg-[#FFFAEB]">
                    <TriangleAlert color="#F79009" size={14} />
                    <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#B54708]">Incomplete</span>
                </div>
            );
        case "initialized":
            return (
                <div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#D9D6FE] tw-bg-[#F4F3FF]">
                    <FileCog color="#7A5AF8" size={14} />
                    <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#5925DC]">Initialized</span>
                </div>
            );
        case "scanning_data_assets":
            return (
                <div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#B2DDFF] tw-bg-[#EFF8FF]">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.25 6.82027V2.91602M12.25 2.91602C12.25 3.88251 9.89949 4.66602 7 4.66602C4.1005 4.66602 1.75 3.88251 1.75 2.91602M12.25 2.91602C12.25 1.94952 9.89949 1.16602 7 1.16602C4.1005 1.16602 1.75 1.94952 1.75 2.91602M12.8333 12.8327L11.7396 11.7389M1.75 6.99935C1.75014 7.45325 2.27933 7.88937 3.2259 8.21566C4.17246 8.54196 5.46233 8.7329 6.82325 8.74818M1.75 2.91602V11.0827C1.74989 11.3171 1.89108 11.5491 2.16518 11.765C2.43927 11.9809 2.84069 12.1762 3.34561 12.3394C3.85052 12.5026 4.44864 12.6303 5.10446 12.7149C5.76027 12.7995 6.46042 12.8394 7.16333 12.8321M12.25 10.4993C12.25 11.4658 11.4665 12.2493 10.5 12.2493C9.5335 12.2493 8.75 11.4658 8.75 10.4993C8.75 9.53285 9.5335 8.74935 10.5 8.74935C11.4665 8.74935 12.25 9.53285 12.25 10.4993Z" stroke="#2E90FA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#175CD3]">Scanning Data Assets</span>
                </div>
            );
        case "configuring_integrations_failed":
            return (
                <div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#FECDCA] tw-bg-[#FEF3F2]">
                    <CircleX color="#F04438" size={14} />
                    <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#B42318]">Configuring Integrations Failed</span>
                </div>
            );
        case "completed":
            return (
                <div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#ABEFC6] tw-bg-[#ECFDF3]">
                    <CircleCheck color="#067647" size={14} />
                    <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#067647]">Completed</span>
                </div>
            );
        case "configuring_integrations":
            return (
                <div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#FEDF89] tw-bg-[#FFFAEB]">
                    <Wrench color="#F79009" size={14} />
                    <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#B54708]">Configuring Integrations</span>
                </div>
            );
        case "scanning_data_assets_failed":
            return (
                <div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#FCCEEE] tw-bg-[#FDF2FA]">
                    <FileSearchCorner color="#EE46BC" size={14} />
                    <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#C11574]">Scanning Data Assets Failed</span>
                </div>
            );
            case "no_datasets_found_yet":
            return (
               <div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-bg-[#FAFAFA] dark:tw-bg-[#161622]">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <path d="M20.5633 15.8005C21.1452 16.0642 21.1452 16.9431 20.5633 17.2068L12.3739 20.9187C12.1349 21.0269 11.8648 21.0268 11.6258 20.9187L3.43637 17.2068C2.85454 16.9431 2.85454 16.0642 3.43637 15.8005L5.47055 14.8787L11.161 17.4578C11.4271 17.5783 11.7091 17.6394 11.9998 17.6394C12.2906 17.6394 12.573 17.5783 12.8387 17.4578L18.5291 14.8787L20.5633 15.8005Z" fill="#717680" />
                        <path d="M11.161 12.9578C11.4271 13.0783 11.7091 13.1394 11.9998 13.1394C12.1812 13.1394 12.3583 13.1123 12.5311 13.0652C13.6295 13.8909 14.9475 14.4381 16.3817 14.6082L12.3739 16.4255C12.1349 16.5338 11.8648 16.5337 11.6258 16.4255L3.43637 12.7136C2.85454 12.45 2.85454 11.571 3.43637 11.3074L5.47836 10.3816L11.161 12.9578Z" fill="#717680" />
                        <path d="M9.82407 3.89819C9.50595 4.76076 9.33285 5.69371 9.33285 6.66675C9.33289 8.5653 9.99552 10.3086 11.1004 11.6804L3.43637 8.20386C2.85454 7.93984 2.85454 7.06065 3.43637 6.79663L9.82407 3.89819Z" fill="#717680" />
                        <path d="M14.9689 9.96418L17.3017 7.63143L19.6344 9.96418L20.6342 8.96443L18.3347 6.665L20.6675 4.33225L19.6677 3.3325L17.335 5.66525L15.0022 3.3325L14.0025 4.33225L16.3352 6.665L14.0025 8.99775L14.9689 9.96418ZM17.335 13.33C15.491 13.33 13.9192 12.6802 12.6195 11.3805C11.3198 10.0808 10.67 8.50898 10.67 6.665C10.67 4.82102 11.3198 3.24919 12.6195 1.94951C13.9192 0.649838 15.491 0 17.335 0C19.179 0 20.7508 0.649838 22.0505 1.94951C23.3501 3.24919 24 4.82102 24 6.665C24 8.50898 23.3501 10.0808 22.0505 11.3805C20.7508 12.6802 19.179 13.33 17.335 13.33Z" fill="#F64E60" />
                    </svg>
                    <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#B42318]">No Datasets Found</span>
                </div>
            );
        default:
            return (
                <div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-bg-[#FAFAFA] dark:tw-bg-[#161622]">
                    <CircleDashed color="#717680" size={14} />
                    <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#414651] dark:tw-text-[#B2B5BE]">Unknown Status</span>
                </div>
                //No Dataset Found
                // <div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-bg-[#FAFAFA] dark:tw-bg-[#161622]">
                //     <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none">
                //         <path d="M20.5633 15.8005C21.1452 16.0642 21.1452 16.9431 20.5633 17.2068L12.3739 20.9187C12.1349 21.0269 11.8648 21.0268 11.6258 20.9187L3.43637 17.2068C2.85454 16.9431 2.85454 16.0642 3.43637 15.8005L5.47055 14.8787L11.161 17.4578C11.4271 17.5783 11.7091 17.6394 11.9998 17.6394C12.2906 17.6394 12.573 17.5783 12.8387 17.4578L18.5291 14.8787L20.5633 15.8005Z" fill="#717680" />
                //         <path d="M11.161 12.9578C11.4271 13.0783 11.7091 13.1394 11.9998 13.1394C12.1812 13.1394 12.3583 13.1123 12.5311 13.0652C13.6295 13.8909 14.9475 14.4381 16.3817 14.6082L12.3739 16.4255C12.1349 16.5338 11.8648 16.5337 11.6258 16.4255L3.43637 12.7136C2.85454 12.45 2.85454 11.571 3.43637 11.3074L5.47836 10.3816L11.161 12.9578Z" fill="#717680" />
                //         <path d="M9.82407 3.89819C9.50595 4.76076 9.33285 5.69371 9.33285 6.66675C9.33289 8.5653 9.99552 10.3086 11.1004 11.6804L3.43637 8.20386C2.85454 7.93984 2.85454 7.06065 3.43637 6.79663L9.82407 3.89819Z" fill="#717680" />
                //         <path d="M14.9689 9.96418L17.3017 7.63143L19.6344 9.96418L20.6342 8.96443L18.3347 6.665L20.6675 4.33225L19.6677 3.3325L17.335 5.66525L15.0022 3.3325L14.0025 4.33225L16.3352 6.665L14.0025 8.99775L14.9689 9.96418ZM17.335 13.33C15.491 13.33 13.9192 12.6802 12.6195 11.3805C11.3198 10.0808 10.67 8.50898 10.67 6.665C10.67 4.82102 11.3198 3.24919 12.6195 1.94951C13.9192 0.649838 15.491 0 17.335 0C19.179 0 20.7508 0.649838 22.0505 1.94951C23.3501 3.24919 24 4.82102 24 6.665C24 8.50898 23.3501 10.0808 22.0505 11.3805C20.7508 12.6802 19.179 13.33 17.335 13.33Z" fill="#F64E60" />
                //     </svg>
                //     <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#B42318]">No Datasets Found</span>
                // </div>
            );
    }
}

export function getIntegrationStatus(type) {
    return   (
        <div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#ABEFC6] tw-bg-[#ECFDF3]">
            <CircleCheck color="#067647" size={14} />
            <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#067647]">{type}</span>
        </div>
        // <div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#B2DDFF] tw-bg-[#EFF8FF]">
        //     <LoaderCircle color="#2E90FA" size={14} />
        //     <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#175CD3]">In Progress</span>
        // </div>
        // <div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#FECDCA] tw-bg-[#FEF3F2]">
        //     <CircleX color="#F04438" size={14} />
        //     <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#B42318]">Failed</span>
        // </div>
        // <div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#D9D6FE] tw-bg-[#F4F3FF]">
        //     <CirclePlay color="#7A5AF8" size={14} />
        //     <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#5925DC]">Initialize</span>
        // </div>
        // <div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-bg-[#FAFAFA] dark:tw-bg-[#161622]">
        //     <CircleDashed color="#717680" size={14} />
        //     <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#414651] dark:tw-text-[#B2B5BE]">Not Yet Started</span>
        // </div>
        // <div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#FEDF89] tw-bg-[#FFFAEB]">
        //     <TriangleAlert color="#F79009" size={14} />
        //     <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#B54708]">Incomplete</span>
        // </div>

        // <div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#D9D6FE] tw-bg-[#F4F3FF]">
        //     <FileCog color="#7A5AF8" size={14} />
        //     <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#5925DC]">Initialized</span>
        // </div>
        // <div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#B2DDFF] tw-bg-[#EFF8FF]">
        //     <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        //         <path d="M12.25 6.82027V2.91602M12.25 2.91602C12.25 3.88251 9.89949 4.66602 7 4.66602C4.1005 4.66602 1.75 3.88251 1.75 2.91602M12.25 2.91602C12.25 1.94952 9.89949 1.16602 7 1.16602C4.1005 1.16602 1.75 1.94952 1.75 2.91602M12.8333 12.8327L11.7396 11.7389M1.75 6.99935C1.75014 7.45325 2.27933 7.88937 3.2259 8.21566C4.17246 8.54196 5.46233 8.7329 6.82325 8.74818M1.75 2.91602V11.0827C1.74989 11.3171 1.89108 11.5491 2.16518 11.765C2.43927 11.9809 2.84069 12.1762 3.34561 12.3394C3.85052 12.5026 4.44864 12.6303 5.10446 12.7149C5.76027 12.7995 6.46042 12.8394 7.16333 12.8321M12.25 10.4993C12.25 11.4658 11.4665 12.2493 10.5 12.2493C9.5335 12.2493 8.75 11.4658 8.75 10.4993C8.75 9.53285 9.5335 8.74935 10.5 8.74935C11.4665 8.74935 12.25 9.53285 12.25 10.4993Z" stroke="#2E90FA" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/>
        //     </svg>
        //     <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#175CD3]">Scanning Data Assets</span>
        // </div>
        // <div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#FECDCA] tw-bg-[#FEF3F2]">
        //     <CircleX color="#F04438" size={14} />
        //     <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#B42318]">Failed</span>
        // </div>
        // <div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#FECDCA] tw-bg-[#FEF3F2]">
        //     <CircleX color="#F04438" size={14} />
        //     <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#B42318]">Configuring Failed</span>
        // </div>
        // <div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#ABEFC6] tw-bg-[#ECFDF3]">
        //     <CircleCheck color="#067647" size={14} />
        //     <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#067647]">Completed</span>
        // </div>
        // <div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#FEDF89] tw-bg-[#FFFAEB]">
        //     <Wrench color="#F79009" size={14} />
        //     <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#B54708]">Configuring Integrations</span>
        // </div>
        // <div className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-[2px] tw-rounded-lg tw-border tw-border-solid tw-border-[#FCCEEE] tw-bg-[#FDF2FA]">
        //     <FileSearchCorner color="#EE46BC" size={14} />
        //     <span className="tw-text-xs tw-font-medium tw-capitalize tw-text-[#C11574]">Scanning Failed</span>
        // </div>
    )
}
